import React, { useEffect, useRef, useState } from 'react';
import Flex from '../../../data/Flex';
import Size from '../../../data/Size';
import UIButton from '../../../ui/UIButton';
import { UIWhiteBox } from '../../../ui/UIContainer';
import UIFlex from '../../../ui/UIFlex';
import { UIForm } from '../../../ui/UIForm';
import UIInput from '../../../ui/UIInput';
import UITitle from '../../../ui/UITitle';
import Api from '../../../api/Api';
import ConfirmOverlay from "../../../ui/overlay/ConfirmOverlay";
import './ManageUser.scss';
import UIContainer from '../../../ui/UIContainer';
import FormatUtil,{IHash} from '../../../util/FormatUtil';
import { useNavigate } from 'react-router-dom';
import  LoginView  from '../../../view/LoginView';
import Color from '../../../data/Color';

export interface IUserProps {
    title?:string;
    message?:string;
    sendLabel?:string;
    onCancel:()=>void;
    email:string;
}

export interface IEmailState{
    passcode:string;
    password:string;
    passwordConfirmation:string;
}

export function NewPassword($props:IUserProps){

    const navigation = useNavigate();
    
    const [validFieldsUpdate, setShowValidFieldsUpdate] = useState(false);

    const defaultEmailState:IEmailState = {
        passcode:"",
        password:"",
        passwordConfirmation:"",
    }

    const [emailState, setEmailState] = useState<IEmailState>(defaultEmailState);
    
    const manualInputChange=($value:string | number | boolean, $name:string)=>{        
        setEmailState(($prevState)=>{
            let newState:any = {...$prevState};
            newState[$name] = $value;
            return newState;
        });
    }

    const _reset=()=>{        

        let token = emailState.passcode.trim();  
        let email = $props.email.trim();  
        let password = emailState.password.trim();


        if(emailState.password.trim() !== emailState.passwordConfirmation.trim()){
            ConfirmOverlay.show("errorUpdatePassword",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"New Password and New Password Confirmation must be the same ."});
            return;
        }

        const encodedPassword: IHash = FormatUtil.encodePassword(email, password);
        let newPassword = encodedPassword.dbHash;

        Api.cdr.setPassword(($success,$results)=>{
            if($success){
                if($results && $results.summary){
                    ConfirmOverlay.show("updatePassword",{confirmLabel:"Ok", hideCancel:true, title:"Reset Password", message:"Password Updated."});
                    navigation(LoginView.PATH);}
                else{
                    ConfirmOverlay.show("errorUpdatePassword",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Reset Password."});    
                }
            }else{
                ConfirmOverlay.show("errorUpdatePassword",{confirmLabel:"Ok", hideCancel:true, title:"Error", message:"Unable to Reset Password."});
            }
        },{email:email,token:token,passcode:newPassword});

        {$props.onCancel()};

    }


    let generateFieldsCN:string = "generateFields";

    let canSaveDisabled:boolean=true;

    if(emailState.passcode.trim() && emailState.password.trim() && emailState.passwordConfirmation.trim()){
        canSaveDisabled=false;
    }

    if(validFieldsUpdate){
        generateFieldsCN+=" flash";
    }

return (
        <UIFlex flex={{direction:Flex.COLUMN,overflowHidden:true}}>
        <UIWhiteBox className='manageUser' flex={{fullWidth:true, style:{gap:20}}}>
            <UITitle flex={{style:{marginBottom:-10}}} title={$props.title}>
            </UITitle>
            <UIFlex className="message">
                    {$props.message}
                </UIFlex>

            <div className="divider"></div>
            <UIForm flex={{style:{gap:20}}} className={generateFieldsCN}>
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="Verification code" name='passcode' value={emailState.passcode} onChange={manualInputChange} isRequired />     
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="New Password" type={UIInput.TYPE_PASSWORD} name='password' autoComplete={"new-password"} value={emailState.password} onChange={manualInputChange} isRequired />
                <UIInput flex={{fullWidth:true}} fontSize={Size.s14} size={Size.s36} label="New Password Confirmation" type={UIInput.TYPE_PASSWORD} name='passwordConfirmation' autoComplete={"new-password"} value={emailState.passwordConfirmation} onChange={manualInputChange} isRequired/>


            <UIContainer flex={{alignItems:Flex.FLEX_END, justifyContent:Flex.FLEX_END, style:{gap:10, marginTop:20}}} >
            <UIFlex >
                     <UIButton label={"Cancel"}  color={Color.BLUE_PRIMARY} onClick={$props.onCancel}/>
                </UIFlex>  

                  <UIFlex >   
                     <UIButton  disabled={canSaveDisabled} label={$props.sendLabel} onClick={_reset} />
                  </UIFlex>
             </UIContainer>
             </UIForm>

        </UIWhiteBox>
        </UIFlex>  
    );
}
